/**
 * 用户状态管理工具
 * 参考 old_qian 项目的用户数据存储方式
 */

class UserStore {
  constructor() {
    this.storageKeys = {
      token: 'wallet_token',
      userInfo: 'user_info',
      walletInfo: 'wallet_info',
      address: 'address',
      addressType: 'addressType',
      chainType: 'lian'
    }
  }

  /**
   * 检查用户是否已登录
   */
  isLoggedIn() {
    const token = localStorage.getItem(this.storageKeys.token)
    const userInfo = localStorage.getItem(this.storageKeys.userInfo)
    return !!(token && userInfo)
  }

  /**
   * 获取用户信息
   */
  getUserInfo() {
    try {
      const userInfo = localStorage.getItem(this.storageKeys.userInfo)
      return userInfo ? JSON.parse(userInfo) : null
    } catch (error) {
      console.error('获取用户信息失败:', error)
      return null
    }
  }

  /**
   * 获取钱包信息
   */
  getWalletInfo() {
    try {
      const walletInfo = localStorage.getItem(this.storageKeys.walletInfo)
      return walletInfo ? JSON.parse(walletInfo) : null
    } catch (error) {
      console.error('获取钱包信息失败:', error)
      return null
    }
  }

  /**
   * 获取访问令牌
   */
  getToken() {
    return localStorage.getItem(this.storageKeys.token)
  }

  /**
   * 获取钱包地址
   */
  getAddress() {
    return sessionStorage.getItem(this.storageKeys.address) || 
           localStorage.getItem(this.storageKeys.address)
  }

  /**
   * 获取地址类型
   */
  getAddressType() {
    const type = sessionStorage.getItem(this.storageKeys.addressType) || 
                 localStorage.getItem(this.storageKeys.addressType)
    return type ? parseInt(type) : 0
  }

  /**
   * 获取链类型
   */
  getChainType() {
    return sessionStorage.getItem(this.storageKeys.chainType) || 'erc20'
  }

  /**
   * 保存用户登录数据
   */
  saveLoginData(data) {
    try {
      // 保存到 localStorage（持久化）
      localStorage.setItem(this.storageKeys.token, data.token)
      localStorage.setItem(this.storageKeys.userInfo, JSON.stringify(data.user))
      localStorage.setItem(this.storageKeys.walletInfo, JSON.stringify(data.wallet))
      
      // 保存到 sessionStorage（会话级别）
      if (data.wallet && data.wallet.address) {
        sessionStorage.setItem(this.storageKeys.address, data.wallet.address)
        sessionStorage.setItem(this.storageKeys.addressType, data.wallet.address_type.toString())
      }

      console.log('用户登录数据已保存')
      return true
    } catch (error) {
      console.error('保存用户登录数据失败:', error)
      return false
    }
  }

  /**
   * 保存钱包地址（参考 old_qian 的方式）
   */
  saveWalletAddress(address, addressType = 0) {
    sessionStorage.setItem(this.storageKeys.address, address)
    sessionStorage.setItem(this.storageKeys.addressType, addressType.toString())
    localStorage.setItem(this.storageKeys.address, address) // 备份到 localStorage
  }

  /**
   * 保存链类型
   */
  saveChainType(chainType) {
    sessionStorage.setItem(this.storageKeys.chainType, chainType)
  }

  /**
   * 清除用户数据
   */
  clearUserData() {
    // 清除 localStorage
    Object.values(this.storageKeys).forEach(key => {
      localStorage.removeItem(key)
    })

    // 清除 sessionStorage
    Object.values(this.storageKeys).forEach(key => {
      sessionStorage.removeItem(key)
    })

    console.log('用户数据已清除')
  }

  /**
   * 检查钱包连接状态
   */
  checkWalletConnection() {
    const address = this.getAddress()
    const token = this.getToken()
    
    return {
      hasAddress: !!address,
      hasToken: !!token,
      isConnected: !!(address && token)
    }
  }

  /**
   * 获取用户余额信息
   */
  getUserBalance() {
    const userInfo = this.getUserInfo()
    return userInfo ? userInfo.money || 0 : 0
  }

  /**
   * 更新用户余额
   */
  updateUserBalance(balance) {
    const userInfo = this.getUserInfo()
    if (userInfo) {
      userInfo.money = balance
      localStorage.setItem(this.storageKeys.userInfo, JSON.stringify(userInfo))
      return true
    }
    return false
  }
}

// 创建单例实例
const userStore = new UserStore()

export default userStore
